import * as React from "react";
import { page } from "../../components/layout/responsive";
import { QaHeader, QaMeta } from "./containers/QaHeader";

export const QaPage = page({
  mobile: React.lazy(() => import("./containers/QaPage")),
  header: QaHeader,
  meta: QaMeta,
});
